import React, {
  ReactElement, useCallback, useMemo, useState,
} from 'react';
import CurrentUserDetail from '../../../model/currentuser/CurrentUserDetail';
import { useClient } from '../../ClientStatusContext';
import { fetchCurrentPouzivatel } from '../../../client/currentuser/currentUserClient';
import UserContext, { UserContextProperties } from './UserContext';

interface Props {
  children: ReactElement;
}

const UserContextProvider = ({ children }: Props): ReactElement => {
  const [pouzivatel, setPouzivatel] = useState<CurrentUserDetail>(null);
  const loginSuccess = useCallback((user: CurrentUserDetail): void => {
    setPouzivatel(user);
  }, []);

  const { wrapClient } = useClient(fetchCurrentPouzivatel);
  const fetchProfile = useCallback((): void => {
    wrapClient()
      .then(({ data }) => loginSuccess(data));
  }, [loginSuccess, wrapClient]);

  const value: UserContextProperties = useMemo(() => ({
    pouzivatel,
    fetchProfile,
  }), [fetchProfile, pouzivatel]);
  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
};

export default UserContextProvider;
